// extracted by mini-css-extract-plugin
module.exports = {"linkContactWindow":"linkContactWindow__xwGy5"};